import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  PatientHistoryQuestionKey,
  PatientHistoryQuestionTitle,
} from '../constants';
import PatientHistoryCard from './PatientHistoryCard';
import { setHistoryQuestion } from '../state/index';
import { useReady } from '../../hooks';

interface QuestionProps {
  questionKey: PatientHistoryQuestionKey;
}

const PatientHistoryQuestion = React.memo(({ questionKey }: QuestionProps) => {
  const dispatch = useDispatch();

  const selector = (state: any) =>
    state.medicalRecords.currentRecord.patientHistory[questionKey] || {};

  const {
    response: responseValue,
    observation: observationValue,
  } = useSelector(selector);

  const ready = useReady();

  const title = PatientHistoryQuestionTitle[questionKey];

  const handleChange = (response: boolean, observation?: string) => {
    dispatch(
      setHistoryQuestion({
        question: PatientHistoryQuestionKey[questionKey],
        response,
        observation,
      }),
    );
  };

  return (
    <PatientHistoryCard
      title={title}
      response={responseValue}
      observation={observationValue}
      onChange={handleChange}
      onTextChangeImmediate={ready}
      data-testid={questionKey}
    />
  );
});

export default PatientHistoryQuestion;
